import React, { useState, useEffect, useRef } from 'react'
import Layout from '../containers/layout'
import SEO from "../components/seo";
import './landing.css'
import CloudIndexTable from '../components/cloudIndexTable/cloudIndexTable'
import Lottie from '../components/Lottie'

import { graphql, Link, useStaticQuery } from 'gatsby'
import headerStyles from '../components/header.module.css'
import footerStyles from '../components/footer/footer.module.css'
import { useWindowSize } from '../hooks/useWindowSize.hook'
import linkStyle from '../styles/components/links.module.css'
import * as styles from './infrared/infra.module.css'
import Icon from '../components/icons'

import aiAnimation from '../img/landing/ai.json'
import humanAnimation from '../img/landing/human.json'

import aaru from '../img/logos/green/aaru-logo/aaru-logo.png'
import aaruHover from '../img/logos/green/aaru-logo/aaru-logo-hover.png'
import abridge from '../img/logos/green/abridge-logo/abridge-logo.png'
import abridgeHover from '../img/logos/green/abridge-logo/abridge-logo-hover.png'
import anam from '../img/logos/green/anam-logo/anam-logo.png'
import anamHover from '../img/logos/green/anam-logo/anam-logo-hover.png'
import assorthealth from '../img/logos/green/assorthealth-logo/assorthealth-logo.png'
import assorthealthHover from '../img/logos/green/assorthealth-logo/assorthealth-logo-hover.png'
import attivo from '../img/logos/green/attivo-logo/attivo-logo.png'
import attivoHover from '../img/logos/green/attivo-logo/attivo-logo-hover.png'
import avoca from '../img/logos/green/avoca-logo/avoca-logo.png'
import avocaHover from '../img/logos/green/avoca-logo/avoca-logo-hover.png'
import basis from '../img/logos/green/basis-logo/basis-logo.png'
import basicHover from '../img/logos/green/basis-logo/basis-logo-hover.png'
import bland from '../img/logos/green/bland-logo/bland-logo.png'
import blandHover from '../img/logos/green/bland-logo/bland-logo-hover.png'
import boon from '../img/logos/green/boon-logo/boon-logo.png'
import boonHover from '../img/logos/green/boon-logo/boon-logo-hover.png'
import bobyard from '../img/logos/green/bobyard-logo/bobyard-logo.png'
import bobyardHover from '../img/logos/green/bobyard-logo/bobyard-logo-hover.png'
import clay from '../img/logos/green/clay-logo/clay-logo.png'
import clayHover from '../img/logos/green/clay-logo/clay-logo-hover.png'
import cognition from '../img/logos/green/cognition-logo/сognition-logo.png'
import cognitionHover from '../img/logos/green/cognition-logo/сognition-logo-hover.png'
import collate from '../img/logos/green/collate-logo/collate-logo.png'
import collateHover from '../img/logos/green/collate-logo/collate-logo-hover.png'
import consoleLogo from '../img/logos/green/console-logo/console-logo.png'
import consoleHover from '../img/logos/green/console-logo/console-logo-hover.png'
import counsel from '../img/logos/green/counsel-logo/counsel-logo.png'
import counselHover from '../img/logos/green/counsel-logo/counsel-logo-hover.png'
import cursor from '../img/logos/green/cursor-logo/cursor-logo.png'
import cursorHover from '../img/logos/green/cursor-logo/cursor-logo-hover.png'
import decagon from '../img/logos/green/decagon-logo/decagon-logo.png'
import decagonHover from '../img/logos/green/decagon-logo/decagon-logo-hover.png'
import distyl from '../img/logos/green/distyl-logo/distyl-logo.png'
import distylHover from '../img/logos/green/distyl-logo/distyl-logo-hover.png'
import evenup from '../img/logos/green/evenup-logo/evenup-logo.png'
import evenupHover from '../img/logos/green/evenup-logo/evenup-logo-hover.png'
import everest from '../img/logos/green/everest-logo/everest-logo.png'
import everestHover from '../img/logos/green/everest-logo/everest-logo-hover.png'
import finch from '../img/logos/green/finch-logo/finch-logo.png'
import finchHover from '../img/logos/green/finch-logo/finch-logo-hover.png'
import floraai from '../img/logos/green/floraai-logo/floraai-logo.png'
import floraaiHover from '../img/logos/green/floraai-logo/floraai-logo-hover.png'
import gamma from '../img/logos/green/gamma-logo/gamma-logo.png'
import gammaHover from '../img/logos/green/gamma-logo/gamma-logo-hover.png'
import gigaml from '../img/logos/green/gigaml-logo/gigaml-logo.png'
import gigamlHover from '../img/logos/green/gigaml-logo/gigaml-logo-hover.png'
import glean from '../img/logos/green/glean-logo/glean-logo.png'
import gleanHover from '../img/logos/green/glean-logo/glean-logo-hover.png'
import goaugment from '../img/logos/green/goaugment-logo/goaugment-logo.png'
import goaugmentHover from '../img/logos/green/goaugment-logo/goaugment-logo-hover.png'
import gradientlabs from '../img/logos/green/gradientlabs-logo/gradientlabs-logo.png'
import gradientlabsHover from '../img/logos/green/gradientlabs-logo/gradientlabs-logo-hover.png'
import happyrobot from '../img/logos/green/happyrobot-logo/happyrobot-logo.png'
import happyrobotHover from '../img/logos/green/happyrobot-logo/happyrobot-logo-hover.png'
import harvey from '../img/logos/green/harvey-logo/harvey-logo.png'
import harveyHover from '../img/logos/green/harvey-logo/harvey-logo-hover.png'
import hebbia from '../img/logos/green/hebbia-logo/hebbia-logo.png'
import hebbiaHover from '../img/logos/green/hebbia-logo/hebbia-logo-hover.png'
import heygen from '../img/logos/green/heygen-logo/heygen-logo.png'
import heygenHover from '../img/logos/green/heygen-logo/heygen-logo-hover.png'
import juicebox from '../img/logos/green/juicebox-logo/juicebox-logo.png'
import juiceboxHover from '../img/logos/green/juicebox-logo/juicebox-logo-hover.png'
import latent from '../img/logos/green/latent-logo/latent-logo.png'
import latentHover from '../img/logos/green/latent-logo/latent-logo-hover.png'
import legora from '../img/logos/green/legora-logo/legora-logo.png'
import legoraHover from '../img/logos/green/legora-logo/legora-logo-hover.png'
import liberate from '../img/logos/green/liberate-logo/liberate-logo.png'
import liberateHover from '../img/logos/green/liberate-logo/liberate-logo-hover.png'
import listen from '../img/logos/green/listen-logo/listen-logo.png'
import listenHover from '../img/logos/green/listen-logo/listen-logo-hover.png'
import lovable from '../img/logos/green/lovable-logo/lovable-logo.png'
import lovableHover from '../img/logos/green/lovable-logo/lovable-logo-hover.png'
import mandolin from '../img/logos/green/mandolin-logo/mandolin-logo.png'
import mandolinHover from '../img/logos/green/mandolin-logo/mandolin-logo-hover.png'
import maxima from '../img/logos/green/maxima-logo/maxima-logo.png'
import maximaHover from '../img/logos/green/maxima-logo/maxima-logo-hover.png'
import mercor from '../img/logos/green/mercor-logo/mercor-logo.png'
import mercorHover from '../img/logos/green/mercor-logo/mercor-logo-hover.png'
import n8n from '../img/logos/green/n8n-logo/n8n-logo.png'
import n8nHover from '../img/logos/green/n8n-logo/n8n-logo-hover.png'
import netic from '../img/logos/green/netic-logo/netic-logo.png'
import neticHover from '../img/logos/green/netic-logo/netic-logo-hover.png'
import nooks from '../img/logos/green/nooks-logo/nooks-logo.png'
import nooksHover from '../img/logos/green/nooks-logo/nooks-logo-hover.png'
import normai from '../img/logos/green/normai-logo/normai-logo.png'
import normaiHover from '../img/logos/green/normai-logo/normai-logo-hover.png'
import openevidence from '../img/logos/green/openevidence-logo/openevidence-logo.png'
import openevidenceHover from '../img/logos/green/openevidence-logo/openevidence-logo-hover.png'
import owner from '../img/logos/green/owner-logo/owner-logo.png'
import ownerHover from '../img/logos/green/owner-logo/owner-logo-hover.png'
import perploxity from '../img/logos/green/perploxity-logo/perploxity-logo.png'
import perploxityHover from '../img/logos/green/perploxity-logo/perploxity-logo-hover.png'
import probook from '../img/logos/green/probook-logo/probook-logo.png'
import probookHover from '../img/logos/green/probook-logo/probook-logo-hover.png'
import profound from '../img/logos/green/profound-logo/profound-logo.png'
import profoundHover from '../img/logos/green/profound-logo/profound-logo-hover.png'
import pylon from '../img/logos/green/pylon-logo/pylon-logo.png'
import pylonHover from '../img/logos/green/pylon-logo/pylon-logo-hover.png'
import qualified from '../img/logos/green/qualified-logo/qualified-logo.png'
import qualifiedHover from '../img/logos/green/qualified-logo/qualified-logo-hover.png'
import raspberryai from '../img/logos/green/raspberryai-logo/raspberryai-logo.png'
import raspberryaiHover from '../img/logos/green/raspberryai-logo/raspberryai-logo-hover.png'
import replit from '../img/logos/green/replit-logo/replit-logo.png'
import replitHover from '../img/logos/green/replit-logo/replit-logo-hover.png'
import rillet from '../img/logos/green/rillet-logo/rillet-logo.png'
import rilletHover from '../img/logos/green/rillet-logo/rillet-logo-hover.png'
import rogo from '../img/logos/green/rogo-logo/rogo-logo.png'
import rogoHover from '../img/logos/green/rogo-logo/rogo-logo-hover.png'
import rox from '../img/logos/green/rox-logo/rox-logo.png'
import roxHover from '../img/logos/green/rox-logo/rox-logo-hover.png'
import runway from '../img/logos/green/runway-logo/runway-logo.png'
import runwayHover from '../img/logos/green/runway-logo/runway-logo-hover.png'
import salient from '../img/logos/green/salient-logo/salient-logo.png'
import salientHover from '../img/logos/green/salient-logo/salient-logo-hover.png'
import serval from '../img/logos/green/serval-logo/serval-logo.png'
import servalHover from '../img/logos/green/serval-logo/serval-logo-hover.png'
import sierra from '../img/logos/green/sierra-logo/sierra-logo.png'
import sierraHover from '../img/logos/green/sierra-logo/sierra-logo-hover.png'
import silent from '../img/logos/green/silent-logo/silent-logo.png'
import silentHover from '../img/logos/green/silent-logo/silent-logo-hover.png'
import synthesia from '../img/logos/green/synthesia-logo/synthesia-logo.png'
import synthesiaHover from '../img/logos/green/synthesia-logo/synthesia-logo-hover.png'
import tandem from '../img/logos/green/tandem-logo/tandem-logo.png'
import tandemHover from '../img/logos/green/tandem-logo/tandem-logo-hover.png'
import tennr from '../img/logos/green/tennr-logo/tennr-logo.png'
import tennrHover from '../img/logos/green/tennr-logo/tennr-logo-hover.png'
import traversal from '../img/logos/green/traversal-logo/traversal-logo.png'
import traversalHover from '../img/logos/green/traversal-logo/traversal-logo-hover.png'
import trunktools from '../img/logos/green/trunktools-logo/trunktools-logo.png'
import trunktoolsHover from '../img/logos/green/trunktools-logo/trunktools-logo-hover.png'
import unify from '../img/logos/green/unify-logo/unify-logo.png'
import unifyHover from '../img/logos/green/unify-logo/unify-logo-hover.png'
import valeriehealth from '../img/logos/green/valeriehealth-logo/valeriehealth-logo.png'
import valeriehealthHover from '../img/logos/green/valeriehealth-logo/valeriehealth-logo-hover.png'
import weavygrey from '../img/logos/green/weavygrey-logo/weavygrey-logo.png'
import weavygreayHover from '../img/logos/green/weavygrey-logo/weavygrey-logo-hover.png'
import writergreen from '../img/logos/green/writergreen-logo/writergreen-logo.png'
import writergreenHover from '../img/logos/green/writergreen-logo/writergreen-logo-hover.png'
import zedindustriesgreen from '../img/logos/green/zedindustriesgreen-logo/zedindustriesgreen-logo.png'
import zedindustriesgreenHover from '../img/logos/green/zedindustriesgreen-logo/zedindustriesgreen-logo-hover.png'
// import redpoint from '../img/logos/green/redpoint-logo/redpoint-logo.svg'
// import redpointHover from '../img/logos/green/redpoint-logo/redpoint-logo-hover.svg'

export default function Ai64 (props) {
  const observerTargetRef = useRef(null)
  const { width } = useWindowSize()

  const data = useStaticQuery(graphql`
      query LandingQuery {
          content: sanityPage(title: { eq: "AI 64" }) {
              title
              _rawBody
              metaTitle
              metaDescription
              metaKeywords
              metaImage {
                  asset {
                      _id
                      url
                  }
              }
              ai64 {
                  hero {
                      backgroundVideo {
                          asset {
                              _id
                              url
                          }
                      }
                      videoPoster {
                          asset {
                              _id
                              url
                          }
                      }
                      headingImage {
                          asset {
                              _id
                              url
                          }
                      }
                  }
                  secondSection {
                      heading
                      text
                      downloadButtonText
                      downloadButtonTextMobile
                  }
                  infraredThirdSection {
                      heading
                      text
                      lottieFile {
                          asset {
                              _id
                              url
                          }
                      }
                  }
                  saasToSasSection {
                      title
                      description
                      saasFeatures
                      sasFeatures
                  }
                  aiAdvancingSection {
                      title
                      description
                      annualizedRevenueChart {
                          asset {
                              _id
                              url
                          }
                      }
                      valuationsChart {
                          asset {
                              _id
                              url
                          }
                      }
                  }
                  participatingPartnersSection {
                      title
                      partners {
                          name
                          logo {
                              asset {
                                  _id
                                  url
                              }
                          }
                      }
                  }
                  sixthSection {
                      backgroundImage {
                          asset {
                              _id
                              url
                          }
                      }
                      heading
                      text
                      downloadButtonText
                      downloadButtonTextMobile
                      documents {
                          year
                          googleDriveLink
                      }
                  }
              }
          }

          ai64Table: allGoogleAi64FinalTableSheet {
              nodes {
                  company
                  logoRef: logo
                  url
                  stage
                  location
                  totalRaisedToDate
                  subcategory
                  portfolio
              }
          }
      }
  `)

  const logos = {
    aaru: aaru,
    aaruHover: aaruHover,
    abridge: abridge,
    abridgeHover: abridgeHover,
    anam: anam,
    anamHover: anamHover,
    assorthealth: assorthealth,
    assorthealthHover: assorthealthHover,
    attio: attivo,
    attioHover: attivoHover,
    avoca: avoca,
    avocaHover: avocaHover,
    basis: basis,
    basisHover: basicHover,
    blandai: bland,
    blandaiHover: blandHover,
    boon: boon,
    boonHover: boonHover,
    bobyard: bobyard,
    bobyardHover: bobyardHover,
    clay: clay,
    clayHover: clayHover,
    cognition: cognition,
    cognitionHover: cognitionHover,
    console: consoleLogo,
    consoleHover: consoleHover,
    counselhealth: counsel,
    counselhealthHover: counselHover,
    collate: collate,
    collateHover: collateHover,
    cursor: cursor,
    cursorHover: cursorHover,
    decagon: decagon,
    decagonHover: decagonHover,
    distyl: distyl,
    distylHover: distylHover,
    evenup: evenup,
    evenupHover: evenupHover,
    everest: everest,
    everestHover: everestHover,
    finchlegal: finch,
    finchlegalHover: finchHover,
    florafauna: floraai,
    florafaunaHover: floraaiHover,
    gamma: gamma,
    gammaHover: gammaHover,
    gigaml: gigaml,
    gigamlHover: gigamlHover,
    glean: glean,
    gleanHover: gleanHover,
    augment: goaugment,
    augmentHover: goaugmentHover,
    gradientlabs: gradientlabs,
    gradientlabsHover: gradientlabsHover,
    happyrobot: happyrobot,
    happyrobotHover: happyrobotHover,
    harvey: harvey,
    harveyHover: harveyHover,
    hebbia: hebbia,
    hebbiaHover: hebbiaHover,
    heygen: heygen,
    heygenHover: heygenHover,
    juicebox: juicebox,
    juiceboxHover: juiceboxHover,
    latenthealth: latent,
    latenthealthHover: latentHover,
    legora: legora,
    legoraHover: legoraHover,
    liberate: liberate,
    liberateHover: liberateHover,
    listenlabs: listen,
    listenlabsHover: listenHover,
    lovable: lovable,
    lovableHover: lovableHover,
    mandolin: mandolin,
    mandolinHover: mandolinHover,
    maxima: maxima,
    maximaHover: maximaHover,
    mercor: mercor,
    mercorHover: mercorHover,
    n8n: n8n,
    n8nHover: n8nHover,
    netic: netic,
    neticHover: neticHover,
    nooks: nooks,
    nooksHover: nooksHover,
    normai: normai,
    normaiHover: normaiHover,
    openevidence: openevidence,
    openevidenceHover: openevidenceHover,
    owner: owner,
    ownerHover: ownerHover,
    perplexityai: perploxity,
    perplexityaiHover: perploxityHover,
    probook: probook,
    probookHover: probookHover,
    profound: profound,
    profoundHover: profoundHover,
    pylon: pylon,
    pylonHover: pylonHover,
    qualified: qualified,
    qualifiedHover: qualifiedHover,
    raspberryai: raspberryai,
    raspberryaiHover: raspberryaiHover,
    replit: replit,
    replitHover: replitHover,
    rillet: rillet,
    rilletHover: rilletHover,
    rogo: rogo,
    rogoHover: rogoHover,
    rox: rox,
    roxHover: roxHover,
    runway: runway,
    runwayHover: runwayHover,
    salient: salient,
    salientHover: salientHover,
    serval: serval,
    servalHover: servalHover,
    sierra: sierra,
    sierraHover: sierraHover,
    silent: silent,
    silentHover: silentHover,
    synthesia: synthesia,
    synthesiaHover: synthesiaHover,
    tandem: tandem,
    tandemHover: tandemHover,
    tennr: tennr,
    tennrHover: tennrHover,
    traversal: traversal,
    traversalHover: traversalHover,
    trunktools: trunktools,
    trunktoolsHover: trunktoolsHover,
    unify: unify,
    unifyHover: unifyHover,
    valeriehealth: valeriehealth,
    valeriehealthHover: valeriehealthHover,
    weavy: weavygrey,
    weavyHover: weavygreayHover,
    writer: writergreen,
    writerHover: writergreenHover,
    zed: zedindustriesgreen,
    zedHover: zedindustriesgreenHover
  }

  const createLogo = (logoRef, company) => (
    <>
      <img src={logos[logoRef]} alt={company} className='default' />
      <img src={logos[`${logoRef}Hover`]} alt={company} className='hover' />
    </>
  )

  const transformNodes = (nodes) =>
    nodes.map(c => ({
      ...c,
      logo: () => createLogo(c.logoRef, c.company) || null
    }))

  const ai64Table = data?.ai64Table?.nodes && transformNodes(data.ai64Table.nodes)

  useEffect(() => {
    const header = document.querySelector('header')
    const handleIntersection = (entries) => {
      if (!header) return

      entries.forEach((entry) => {
        // Only add transparent class when intersecting and not scrolled
        if (entry.isIntersecting && !document.documentElement.classList.contains('scrolled')) {
          header.classList.add(headerStyles.transparent)
          header.classList.remove(headerStyles.gbColor)
        } else {
          header.classList.remove(headerStyles.transparent)
          header.classList.add(headerStyles.gbColor)
        }
      })
    }

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1
    })

    if (observerTargetRef.current) {
      observer.observe(observerTargetRef.current)
    }

    // Add scroll event listener to ensure header class is updated on scroll
    const handleScroll = () => {
      if (!header) return

      if (window.scrollY > 50) {
        // When scrolled, remove transparent and add gbColor
        header.classList.remove(headerStyles.transparent)
        header.classList.add(headerStyles.gbColor)
      } else {
        // When at top and not scrolled, add transparent and remove gbColor
        header.classList.add(headerStyles.transparent)
        header.classList.remove(headerStyles.gbColor)
      }
    }

    window.addEventListener('scroll', handleScroll)

    // window.addEventListener('resize', handleResize)
    // adjustLetterSpacing()

    return () => {
      // window.removeEventListener('resize', handleResize)
      if (observerTargetRef.current) {
        observer.unobserve(observerTargetRef.current)
      }
      window.removeEventListener('scroll', handleScroll)
      // if (imgRef) {
      //   imgRef.removeEventListener('load', adjustLetterSpacing)
      // }
    }
  }, [])

  const headers = [
    {
      label: 'Company',
      data: 'logo',
      format: 'component',
      orderby: true
    },
    {
      label: 'Stage',
      data: 'stage',
      orderby: true
    },
    {
      label: 'Location',
      data: 'location'
    },
    {
      label: 'Total Funding',
      data: 'totalFunding',
      orderby: true
    },
    {
      label: 'Total Raised to Date',
      data: 'totalRaisedToDate',
      orderby: true
    },
    {
      label: 'Subcategory',
      data: 'subcategory'
    }
  ]

  useEffect(() => {
    // Add class to html element for landing page styling
    document.documentElement.classList.add('landing-page-active')

    const handleScroll = () => {
      const header = document.querySelector('header')
      const footer = document.querySelector('footer')
      // Add/remove scrolled class to html element
      if (window.scrollY > 50) {
        document.documentElement.classList.add('scrolled')
        // Remove transparent class from header when scrolled
        if (header) {
          header.classList.remove(headerStyles.transparent)
        }
        // Add black background to footer when scrolled
        if (footer) {
          footer.classList.add(footerStyles.black)
          footer.classList.add(footerStyles.morePadding)
        }
      } else {
        document.documentElement.classList.remove('scrolled')
        // Add transparent class back to header when scrolled back to top
        if (header) {
          header.classList.add(headerStyles.transparent)
        }
        // Remove black background from footer when scrolled back to top
        if (footer) {
          footer.classList.remove(footerStyles.black)
        }
      }
    }

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll)

    // Call handler once on mount to set initial state
    handleScroll()

    // Clean up on unmount
    return () => {
      document.documentElement.classList.remove('landing-page-active')
      document.documentElement.classList.remove('scrolled')
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  function downloadLink (viewLink) {
    if (!viewLink) return null
    const fileIdMatch = viewLink.match(/\/d\/([a-zA-Z0-9_-]+)\//)
    if (fileIdMatch && fileIdMatch[1]) {
      const fileId = fileIdMatch[1]
      return `https://drive.google.com/uc?export=download&id=${fileId}`
    } else {
      return viewLink
    }
  }

  function trackDownload () {
    if (typeof gtag !== 'undefined') {
      gtag('event', `download_the_report_ai64`, {
        component: 'button'
      })
    }
  }

  return (
    <Layout palette='transparent'>
      <SEO
          title={data?.content?.metaTitle || data?.content?.title} description={data?.content?.metaDescription}
          keywords={data?.content?.metaKeywords ? data?.content?.metaKeywords.split(',') : []}
          imageFB={data?.content?.metaImage.asset.url}
      />
      <div className='landing-container'>
        <section className='landing-hero'>
          {data?.content?.ai64?.hero?.backgroundVideo?.asset.url && (
            <video
              autoPlay
              muted
              loop
              playsInline
              className='hero-video'
              aria-hidden='true'
            >
              <source src={data.content.ai64.hero.backgroundVideo.asset.url} type='video/mp4' />
            </video>
          )}
          <div className='hero-cta'>
            <div className='cta-inner'>
              <div className='cta-left'>
                {data?.content?.ai64?.secondSection?.heading && <div className='cta-title'>{data.content.ai64.secondSection.heading}</div>}
                {data?.content?.ai64?.secondSection?.text && <div className='cta-sub'>{data.content.ai64.secondSection.text}</div>}
              </div>
              <div className='cta-right'>
                <a
                  href={downloadLink(data?.content?.ai64?.sixthSection?.documents?.[0]?.googleDriveLink)}
                  onClick={() => trackDownload()}
                  style={{
                    fontSize: 24
                  }}
                  rel='noopener noreferrer'
                  target='_blank'
                  className={`${linkStyle.linkArrow} ${linkStyle.white} ${linkStyle.noAnim} ${styles.downloadReportBtn}`}
                >{width > 768 ? (data?.content?.ai64?.sixthSection?.downloadButtonText || 'DOWNLOAD THE REPORT') : (data?.content?.ai64?.sixthSection?.downloadButtonTextMobile || 'DOWNLOAD REPORT')}
                  <span>
                    <div className={`${linkStyle.icon}`}>
                      <Icon width={32} height={32} symbol='downArrowIcon' color='currentColor' />
                    </div>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </section>
        <div className='graphic-wrapper' />
        <section data-section='ai-market' className='ai-market-section'>
          <div className='ai-market-inner'>
            <div className='ai-market-copy'>
              <div className='spark'>
                <svg
                  xmlns='http://www.w3.org/2000/svg' width='67' height='67' viewBox='0 0 67 67'
                  fill='none'
                >
                  <g filter='url(#filter0_d_1_1317)'>
                    <path d='M36.0845 30.6758H30.916V35.8443H36.0845V30.6758Z' fill='#25ED88' />
                    <path d='M36.0845 10H30.916V15.1685H36.0845V10Z' fill='#25ED88' />
                    <path d='M36.0845 51.3516H30.916V56.52H36.0845V51.3516Z' fill='#25ED88' />
                    <path d='M56.7603 30.6758H51.5918V35.8443H56.7603V30.6758Z' fill='#25ED88' />
                    <path d='M15.4087 30.6758H10.2402V35.8443H15.4087V30.6758Z' fill='#25ED88' />
                    <path d='M41.2529 25.5073H36.0845V30.6758H41.2529V25.5073Z' fill='#25ED88' />
                    <path d='M30.916 25.5073H25.7476V30.6758H30.916V25.5073Z' fill='#25ED88' />
                    <path d='M30.916 35.8442H25.7476V41.0127H30.916V35.8442Z' fill='#25ED88' />
                    <path d='M41.2529 35.8442H36.0845V41.0127H41.2529V35.8442Z' fill='#25ED88' />
                    <path d='M46.4214 41.0127H41.2529V46.1812H46.4214V41.0127Z' fill='#25ED88' />
                    <path d='M25.7456 41.0127H20.5771V46.1812H25.7456V41.0127Z' fill='#25ED88' />
                    <path d='M25.7456 20.3369H20.5771V25.5054H25.7456V20.3369Z' fill='#25ED88' />
                    <path d='M46.4214 20.3369H41.2529V25.5054H46.4214V20.3369Z' fill='#25ED88' />
                  </g>
                  <defs>
                    <filter
                      id='filter0_d_1_1317' x='0.240234' y='0' width='66.52' height='66.52'
                      filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'
                    >
                      <feFlood floodOpacity='0' result='BackgroundImageFix' />
                      <feColorMatrix
                        in='SourceAlpha' type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                      />
                      <feOffset />
                      <feGaussianBlur stdDeviation='5' />
                      <feComposite in2='hardAlpha' operator='out' />
                      <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.144736 0 0 0 0 0.93109 0 0 0 0 0.532807 0 0 0 0.5 0'
                      />
                      <feBlend
                        mode='normal' in2='BackgroundImageFix'
                        result='effect1_dropShadow_1_1317'
                      />
                      <feBlend
                        mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1_1317'
                        result='shape'
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              {data?.content?.ai64?.infraredThirdSection.heading && (<h2 dangerouslySetInnerHTML={{ __html: data.content.ai64.infraredThirdSection.heading }} />)}
              {data?.content?.ai64?.infraredThirdSection.text && (<p>{data.content.ai64.infraredThirdSection.text}</p>)}
            </div>

            <div className='ai-market-graph'>
              <div className='lottie-container'>
                {data?.content?.ai64?.infraredThirdSection?.lottieFile && (<LottiePlayer lottieFile={data.content.ai64.infraredThirdSection?.lottieFile} />)}
              </div>
            </div>
          </div>
          <div className='perspective-grid' aria-hidden='true' />
        </section>

        <section data-section='sas' className='sas-section'>
          <div className='sas-grid' aria-hidden='true' />
          <div className='sas-inner'>
            <div className='sas-head'>
              <div className='spark'>
                <svg
                  xmlns='http://www.w3.org/2000/svg' width='67' height='67' viewBox='0 0 67 67'
                  fill='none'
                >
                  <g filter='url(#filter0_d_1_1317)'>
                    <path d='M36.0845 30.6758H30.916V35.8443H36.0845V30.6758Z' fill='#25ED88' />
                    <path d='M36.0845 10H30.916V15.1685H36.0845V10Z' fill='#25ED88' />
                    <path d='M36.0845 51.3516H30.916V56.52H36.0845V51.3516Z' fill='#25ED88' />
                    <path d='M56.7603 30.6758H51.5918V35.8443H56.7603V30.6758Z' fill='#25ED88' />
                    <path d='M15.4087 30.6758H10.2402V35.8443H15.4087V30.6758Z' fill='#25ED88' />
                    <path d='M41.2529 25.5073H36.0845V30.6758H41.2529V25.5073Z' fill='#25ED88' />
                    <path d='M30.916 25.5073H25.7476V30.6758H30.916V25.5073Z' fill='#25ED88' />
                    <path d='M30.916 35.8442H25.7476V41.0127H30.916V35.8442Z' fill='#25ED88' />
                    <path d='M41.2529 35.8442H36.0845V41.0127H41.2529V35.8442Z' fill='#25ED88' />
                    <path d='M46.4214 41.0127H41.2529V46.1812H46.4214V41.0127Z' fill='#25ED88' />
                    <path d='M25.7456 41.0127H20.5771V46.1812H25.7456V41.0127Z' fill='#25ED88' />
                    <path d='M25.7456 20.3369H20.5771V25.5054H25.7456V20.3369Z' fill='#25ED88' />
                    <path d='M46.4214 20.3369H41.2529V25.5054H46.4214V20.3369Z' fill='#25ED88' />
                  </g>
                  <defs>
                    <filter
                      id='filter0_d_1_1317' x='0.240234' y='0' width='66.52' height='66.52'
                      filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'
                    >
                      <feFlood floodOpacity='0' result='BackgroundImageFix' />
                      <feColorMatrix
                        in='SourceAlpha' type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                      />
                      <feOffset />
                      <feGaussianBlur stdDeviation='5' />
                      <feComposite in2='hardAlpha' operator='out' />
                      <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.144736 0 0 0 0 0.93109 0 0 0 0 0.532807 0 0 0 0.5 0'
                      />
                      <feBlend
                        mode='normal' in2='BackgroundImageFix'
                        result='effect1_dropShadow_1_1317'
                      />
                      <feBlend
                        mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1_1317'
                        result='shape'
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              {data?.content?.ai64?.saasToSasSection?.title && <h2 dangerouslySetInnerHTML={{ __html: data.content.ai64.saasToSasSection.title }} />}
              {data?.content?.ai64?.saasToSasSection?.description && <p>{data.content.ai64.saasToSasSection.description}</p>}
            </div>

            <div className='sas-cards'>
              <div className='sas-card'>
                <div className='badge badge-light'>
                  <div className='lottie-container'>
                    {humanAnimation && (<LottiePlayer localAnimation={humanAnimation} />)}
                  </div>
                </div>
                <h3 className='title muted'>SaaS</h3>
                <div className='rows'>
                  {data?.content?.ai64?.saasToSasSection?.saasFeatures?.map((feature, index) => (
                    <div className='row' key={index}>{feature}</div>
                  ))}
                </div>
              </div>

              <div className='sas-card sas-card--green'>
                <div className='badge badge-green'>
                  <div className='lottie-container'>
                    {aiAnimation && (<LottiePlayer localAnimation={aiAnimation} />)}
                  </div>
                </div>
                <h3 className='title'>Service-as-Software</h3>
                <div className='rows'>
                  {data?.content?.ai64?.saasToSasSection?.sasFeatures?.map((feature, index) => (
                    <div className='row highlight' key={index}>{feature}</div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section data-section='ai-advancing' className='ai-advancing-section'>
          <div className='ai-advancing-grid' aria-hidden='true' />
          <div className='ai-advancing-inner'>
            <div className='ai-advancing-head'>
              <div className='spark'>
                <svg
                  xmlns='http://www.w3.org/2000/svg' width='67' height='67' viewBox='0 0 67 67'
                  fill='none'
                >
                  <g filter='url(#filter0_d_1_1317)'>
                    <path d='M36.0845 30.6758H30.916V35.8443H36.0845V30.6758Z' fill='#25ED88' />
                    <path d='M36.0845 10H30.916V15.1685H36.0845V10Z' fill='#25ED88' />
                    <path d='M36.0845 51.3516H30.916V56.52H36.0845V51.3516Z' fill='#25ED88' />
                    <path d='M56.7603 30.6758H51.5918V35.8443H56.7603V30.6758Z' fill='#25ED88' />
                    <path d='M15.4087 30.6758H10.2402V35.8443H15.4087V30.6758Z' fill='#25ED88' />
                    <path d='M41.2529 25.5073H36.0845V30.6758H41.2529V25.5073Z' fill='#25ED88' />
                    <path d='M30.916 25.5073H25.7476V30.6758H30.916V25.5073Z' fill='#25ED88' />
                    <path d='M30.916 35.8442H25.7476V41.0127H30.916V35.8442Z' fill='#25ED88' />
                    <path d='M41.2529 35.8442H36.0845V41.0127H41.2529V35.8442Z' fill='#25ED88' />
                    <path d='M46.4214 41.0127H41.2529V46.1812H46.4214V41.0127Z' fill='#25ED88' />
                    <path d='M25.7456 41.0127H20.5771V46.1812H25.7456V41.0127Z' fill='#25ED88' />
                    <path d='M25.7456 20.3369H20.5771V25.5054H25.7456V20.3369Z' fill='#25ED88' />
                    <path d='M46.4214 20.3369H41.2529V25.5054H46.4214V20.3369Z' fill='#25ED88' />
                  </g>
                  <defs>
                    <filter
                      id='filter0_d_1_1317' x='0.240234' y='0' width='66.52' height='66.52'
                      filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'
                    >
                      <feFlood floodOpacity='0' result='BackgroundImageFix' />
                      <feColorMatrix
                        in='SourceAlpha' type='matrix'
                        values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                        result='hardAlpha'
                      />
                      <feOffset />
                      <feGaussianBlur stdDeviation='5' />
                      <feComposite in2='hardAlpha' operator='out' />
                      <feColorMatrix
                        type='matrix'
                        values='0 0 0 0 0.144736 0 0 0 0 0.93109 0 0 0 0 0.532807 0 0 0 0.5 0'
                      />
                      <feBlend
                        mode='normal' in2='BackgroundImageFix'
                        result='effect1_dropShadow_1_1317'
                      />
                      <feBlend
                        mode='normal' in='SourceGraphic' in2='effect1_dropShadow_1_1317'
                        result='shape'
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              {data?.content?.ai64?.aiAdvancingSection?.title && (<h2 dangerouslySetInnerHTML={{ __html: data.content.ai64.aiAdvancingSection.title }} />)}
              {data?.content?.ai64?.aiAdvancingSection?.description && <p>{data.content.ai64.aiAdvancingSection.description}</p>}
            </div>

            <div className='ai-advancing-charts'>
              <div className='chart-card'>
                <div className='lottie-chart-container'>
                  {data?.content?.ai64?.aiAdvancingSection?.annualizedRevenueChart && (<LottiePlayer lottieFile={data.content.ai64.aiAdvancingSection.annualizedRevenueChart} />)}
                </div>
              </div>

              <div className='chart-card'>
                <div className='lottie-chart-container'>
                  {data?.content?.ai64?.aiAdvancingSection?.valuationsChart && (<LottiePlayer lottieFile={data.content.ai64.aiAdvancingSection.valuationsChart} />)}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className='companies-wrap'>
          <div className='companies-table-container'>
            {ai64Table && ai64Table.length > 0 && (
              <CloudIndexTable headers={headers} data={ai64Table} date='2025' inverse accentColor='#25ED88' />
            )}
          </div>
          <div className='companies-section'>
            <div className='companies-note'>
              {'Footnote: Early stage defined as companies that have raised <$50M, Mid stage defined as companies that have raised $50-300M and Late stage defined as companies that have raised >$300M. Total funding amounts from Pitchbook as of Sept 3rd, 2025 and may include equity, debt, secondary or other financing transactions. Redpoint selects the AI 64 based on market size, product approach, team and momentum. Certain companies selected (as indicated with an asterisk) are Redpoint portfolio companies.'}
            </div>
          </div>
        </section>

        {data?.content?.ai64?.participatingPartnersSection && Array.isArray(data.content.ai64.participatingPartnersSection.partners) && data.content.ai64.participatingPartnersSection.partners.length > 0 && (
          <section className='participating-partners-section'>
            <div className='participating-partners-container'>
              <h2 className='participating-partners-title'>
                {data?.content?.ai64?.participatingPartnersSection.title || 'Participating Partners'}
              </h2>
              <div className='participating-partners-logos'>
                {data?.content?.ai64?.participatingPartnersSection.partners.map((partner, index) => (
                  <div key={index} className='partner-logo'>
                    {partner && partner.logo && partner.logo.asset && partner.logo.asset.url && (
                      <img
                        src={partner.logo.asset.url}
                        alt={partner.name || partner.title || `Partner ${index + 1}`}
                      />
                    )}
                  </div>
                ))}
              </div>
            </div>
          </section>
        )}

        <section className='get-full-report-section'>
          <div className='get-full-report-wrapper' style={{ backgroundImage: data?.content?.ai64?.sixthSection?.backgroundImage?.asset?.url ? `url(${data?.content?.ai64?.sixthSection?.backgroundImage?.asset?.url})` : '' }}>
            <div className='get-full-report-content'>
              <h2>{data?.content?.ai64?.sixthSection.heading}</h2>
              <p>{data?.content?.ai64?.sixthSection.text}</p>
            </div>
            <div className='report-filter'>
              <a
                href={downloadLink(data?.content?.ai64?.sixthSection?.documents?.[0]?.googleDriveLink)}
                onClick={() => trackDownload()}
                style={{
                  fontSize: 24
                }}
                rel='noopener noreferrer'
                target='_blank'
                className={`${linkStyle.linkArrow} ${linkStyle.white} ${linkStyle.noAnim} ${styles.downloadReportBtn}`}
              >{width > 768 ? (data.content.ai64.sixthSection?.downloadButtonText || 'DOWNLOAD THE REPORT') : (data.content.ai64.sixthSection?.downloadButtonTextMobile || 'DOWNLOAD REPORT')}
                <span>
                  <div className={`${linkStyle.icon}`}>
                    <Icon width={32} height={32} symbol='downArrowIcon' color='currentColor' />
                  </div>
                </span>
              </a>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  )
}

const LottiePlayer = ({ lottieFile, localAnimation }) => {
  const [animationData, setAnimationData] = useState(null)
  const containerRef = useRef(null)
  const lottieRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (localAnimation) {
      setAnimationData(localAnimation)
      return
    }

    if (lottieFile?.asset?.url) {
      fetch(lottieFile.asset.url)
        .then(response => response.json())
        .then(data => setAnimationData(data))
        .catch(error => console.error('Error loading Lottie file:', error))
    }
  }, [lottieFile, localAnimation])

  useEffect(() => {
    if (!animationData || !containerRef.current) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
          observer.disconnect()
        }
      },
      {
        threshold: 0.5
      }
    )

    observer.observe(containerRef.current)

    return () => observer.disconnect()
  }, [animationData])

  useEffect(() => {
    if (isVisible && lottieRef.current) {
      lottieRef.current.play()
    }
  }, [isVisible])

  if (!animationData) return <></>

  return (
    <div ref={containerRef}>
      <Lottie
        lottieRef={lottieRef}
        animationData={animationData}
        loop={false}
        autoplay={false}
      />
    </div>
  )
}
